import React from "react";

/**
 * VdV. monogram — official mark extracted from the brand manual
 * (Manual de Marca VdV, Junio 2023 — page 5, "Versión Mínima").
 *
 *   tone="dark"   → dark backgrounds (deep-blue / charcoal / over video).
 *                   Uses the cream-on-transparent inverted asset.
 *   tone="light"  → ivory / off-white backgrounds.
 *                   Uses the original navy-on-cream asset.
 *
 * Sizes map to context. `smLight` is the scrolled-header variant —
 * slightly smaller than `sm` because the header chrome solidifies into
 * an ivory band that reduces the available headroom by ~4px.
 */
const SIZE_MAP = {
  xs: 32,         // mobile / compact
  sm: 40,         // header without scroll (over dark hero)
  smLight: 36,    // header scrolled (over ivory)
  md: 56,         // mid contexts
  lg: 96,         // /the-collection feature block
  xl: 140,        // hero IntroTitleCard
  "2xl": 180,     // login overlay centerpiece
};

export default function Monogram({
  size = "md",
  tone = "dark",
  className = "",
  title = "Viaja de Verdad",
  ...rest
}) {
  const height = typeof size === "number" ? size : SIZE_MAP[size] || 40;
  const src =
    tone === "light"
      ? "/static/brand/vdv-monogram-only-transparent.png"
      : "/static/brand/vdv-monogram-only-onDark.png";
  return (
    <img
      src={src}
      alt={title}
      data-testid="vdv-monogram"
      draggable={false}
      decoding="sync"
      loading="eager"
      style={{ height, width: "auto", display: "block" }}
      className={`select-none ${className}`}
      {...rest}
    />
  );
}
